import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { Chart, ChartConfiguration } from 'chart.js/auto';
import { GroupBarView } from '../global-variables';
import { FormsModule } from '@angular/forms';
@Component({
    selector: 'app-group-bar-view',
    templateUrl: './group-bar-view.component.html',
    styleUrls: ['./group-bar-view.component.scss'],
    imports: [FormsModule]
})
export class GroupBarViewComponent implements OnInit {
  @Input() values: any;
  // set values(values: { xValues: string[],chartId: string, yValues: { promoters: number[], detractors: number[], passives: number[] }, 
    // numberOfUsersRated: number[] 
  /* }) {
    this.xValues = values.xValues;
    this.yValues = values.yValues; */
    // this.numberofUsersRated = values.numberOfUsersRated;
   /*  this.chartId = values.chartId;
    console.log("group bar Values",values);
    this.onChange()
  } */
  id = "groupBar"
  chartId: string = '';
  canvasId = 'groupBar';
  xValues: string[] = [];
  chartLegendSelector = "[data-results-chart-legends]";
  chartName = '';
  yValues: { promoters: number[], detractors: number[], passives: number[] } = {
    promoters: [],
    detractors: [],
    passives: []
  }
  // numberofUsersRated: number[] = []
  chartData: Chart | null = null;
  ngOnChanges(changes: SimpleChanges) {
    if (changes['values'] && changes['values'].currentValue) {
      this.xValues = [...changes['values'].currentValue.xValues];
      this.yValues = {...changes['values'].currentValue.yValues};
      this.chartId = changes['values'].currentValue.chartId;
      this.chartName = changes['values'].currentValue.chartName;
      this.onChange();
    }
  }
  ngOnInit() {
    // const max = Math.max(...this.numberofUsersRated)
    const stepSize = GroupBarView.scales.y.ticks.stepSize
    // GroupBarView.scales.y.max = 25
    // this.prepareBarData()
  }
  ngAfterViewInit(): void {
    const canvas = document.getElementById(this.chartId);
    if (canvas) {
      this.prepareBarData(this.chartId);
    }
  }
  prepareBarData(chartId: string) {
    /* const canvas = <HTMLCanvasElement>document.getElementById(this.canvasId);
    if (canvas) {
      if (this.chartData) {
        this.chartData.destroy();
      }
    } */
    const barPercentage = 0.2
    const data: ChartConfiguration = {
      type: 'bar',
      data: {
        labels: this.xValues,
        datasets: [
          {
            label: "Requests received",
            backgroundColor: "#9467BD",
            data: this.yValues.promoters,
            barPercentage: barPercentage,
            barThickness: 10
          }, {
            label: "Request delivered",
            backgroundColor: "#FF7F0E",
            data: this.yValues.passives,
            barPercentage: barPercentage,
            barThickness: 10
          }, {
            label: "Responses received",
            backgroundColor: "#2CA02C",
            data: this.yValues.detractors,
            barPercentage: barPercentage,
            barThickness: 10
          },
        ],
      },
      options: {
        responsive: true,
        aspectRatio: 573/300,
        interaction: {
          mode: "index",
        },
        plugins: {
          tooltip: {
            titleColor: "black",
            backgroundColor: "white",
            bodyColor: "black",
            borderColor: "black",
            borderWidth: 0.1
          },
          legend: {
            display: true,
            position: 'bottom',
            labels: {
              usePointStyle: true,
              padding: 20,
              font: {
                size: 12
              }
            },            
          },
        },
        scales: GroupBarView.scales,
      }
    }
    this.chartData = new Chart(chartId, data);
  }
  ngOnDestroy() {
    if (this.chartData) {
      this.chartData.destroy();
      this.chartData = null;
    }
  }
  onChange() {
    if (this.chartData) {
      this.chartData.data.labels = this.xValues;
      this.chartData.data.datasets[0].data = this.yValues.promoters
      this.chartData.data.datasets[1].data = this.yValues.passives
      this.chartData.data.datasets[2].data = this.yValues.detractors
      this.chartData.update();

    }
  }
}